// removed by extract-text-webpack-plugin
module.exports = {"contentSection":"_2Jqw2"};